<template>
    <div class="page">
        <el-row class="title-nav" type="flex" justify="space-between">
            <box style="width: 33%">
                <el-row type="flex" align="middle" class="item">
                    <el-col :lg="7" :xl="7">
                        <div class="img-div1">
                            <el-image style="padding: 20px" :src="require('@/assets/img/待办sel@3x.png')"></el-image>
                        </div>
                    </el-col>
                    <el-col :span="10" :offset="1" style="color: #999999">
                        <!-- 我的待办 -->
                        <span>待上架：{{upperCount}}</span><br/>
                        <span>待拣货：{{pickCount}}</span><br/>
                        <span>待配送：{{pickPeiCount}}</span><br/>
                        <span>待质检：{{qualityCount}}</span><br/>
                        <span>已叫料：{{productCount}}</span><br/>
                    </el-col>
                    <!-- <el-col :span="5" :offset="2">
                        <div class="whiteSpace">
                            <span class="num-color1">{{taskCount}}</span>
                            个任务
                        </div>
                    </el-col> -->
                </el-row>
            </box>
            <box style="width: 33%">
                <el-row type="flex" align="middle" class="item" style="padding-top:30px">
                    <el-col :lg="7" :xl="7">
                        <div class="img-div2">
                            <el-image style="padding: 20px" :src="require('@/assets/img/时间@3x.png')"></el-image>
                        </div>
                    </el-col>
                    <el-col :span="11" :offset="1" style="color: #999999">
                        今日处理任务
                    </el-col>
                    <el-col :span="6" :offset="2">
                        <div class="whiteSpace">
                            <span class="num-color2">{{sumDay}}</span>
                            个任务
                        </div>
                    </el-col>
                </el-row>
            </box>
            <box style="width: 33%">
                <el-row type="flex" align="middle" class="item" style="padding-top:30px">
                    <el-col :lg="7" :xl="7">
                        <div class="img-div3">
                            <el-image style="padding: 20px 10px" :src="require('@/assets/img/组838@3x.png')"></el-image>
                        </div>
                    </el-col>
                    <el-col :span="11" :offset="1" style="color: #999999">
                        本周处理任务
                    </el-col>
                    <el-col :span="6" :offset="2">
                        <div class="whiteSpace">
                            <span class="num-color3">{{sumWeek}}</span>
                            个任务
                        </div>
                    </el-col>
                </el-row>
            </box>
        </el-row>
        <div class="title">任务列表</div>
        <el-row style="height: 80px" type="flex">
            <box fill>
                <el-row type="flex" align="middle" class="task-tab">
                    <el-col :lg="24" :xl="24">
                        <el-tabs v-model="taskTab" @tab-click="getHome()" v-if="roleCode == '通道'">
                            <!-- <el-tab-pane label="全部" name="first"></el-tab-pane> -->
                            <el-tab-pane label="生产叫料" name="seventh"></el-tab-pane>
                        </el-tabs>
                        <el-tabs v-model="taskTab" @tab-click="getHome()" v-else-if="roleCode == 'STA'">
                            <!-- <el-tab-pane label="全部" name="first"></el-tab-pane> -->
                            <el-tab-pane label="质量待检" name="sixth"></el-tab-pane>
                        </el-tabs>
                        <el-tabs v-model="taskTab" @tab-click="getHome()" v-else-if="roleCode == 'LEVEL_2'">
                            <!-- <el-tab-pane label="全部" name="first"></el-tab-pane> -->
                            <el-tab-pane label="待上架" name="third"></el-tab-pane>
                            <el-tab-pane label="待拣货" name="fourth"></el-tab-pane>
                            <el-tab-pane label="待配送" name="fifth"></el-tab-pane>
                        </el-tabs>
                        <el-tabs v-model="taskTab" @tab-click="getHome()" v-else>
                            <!-- <el-tab-pane label="全部" name="first"></el-tab-pane> -->
                            <el-tab-pane label="待上架" name="third"></el-tab-pane>
                            <el-tab-pane label="待拣货" name="fourth"></el-tab-pane>
                            <el-tab-pane label="待配送" name="fifth"></el-tab-pane>
                            <el-tab-pane label="质量待检" name="sixth"></el-tab-pane>
                            <el-tab-pane label="生产叫料" name="seventh"></el-tab-pane>
                            <el-tab-pane label="AGV异常报警" name="eighth"></el-tab-pane>
                            <el-tab-pane label="待审批" name="ninth"></el-tab-pane>
                        </el-tabs>
                    </el-col>
                    <el-col :lg="10" :xl="10" :offset="6">
                        <!-- <el-input v-model="search.val1" placeholder="请输入内容" suffix-icon="el-icon-search" /> -->
                        <!-- <el-button class="btn-t-edit">新增</el-button> -->
                    </el-col>
                </el-row>
            </box>
        </el-row>
        <div style="flex: 1; overflow: auto">
            <box v-for="(item, index) in taskList" :key="index">
                <el-row style="padding: 15px 0" type="flex" justify="space-around" align="middle">
                    <el-col :lg="2" :xl="2" v-if="taskTab == 'first'">
                        <div v-if="item.code == '库龄预警'" class="lamp-div1">
                            <el-image style="margin: 23px" :src="require('@/assets/img/安灯预警机制@3x.png')"></el-image>
                        </div>
                        <div v-else-if="item.code == '保质期预警'" class="lamp-div2">
                            <el-image style="margin: 23px" :src="require('@/assets/img/安灯预警机制@3x.png')"></el-image>
                        </div>
                        <div v-else class="lamp-div3">
                            <el-image style="margin: 23px" :src="require('@/assets/img/安灯预警机制@3x.png')"></el-image>
                        </div>
                    </el-col>
                    <el-col :lg="20" :xl="20" v-if="taskTab == 'first'">
                        <el-row style="padding: 9px 0; color: #333333">
                            <el-col :span="9">{{ item.code }}</el-col>
                            <el-col :span="6">人员</el-col>
                            <el-col :span="9">开始时间</el-col>
                        </el-row>
                        <el-row style="padding: 9px 0; color: #666666">
                            <el-col :span="9">{{ item.fcCode }}</el-col>
                            <el-col :span="6">{{ item.person }}</el-col>
                            <el-col :span="9">{{ item.createTime }}</el-col>
                        </el-row>
                    </el-col>
                    <!-- 待上架 -->
                    <el-col :lg="20" :xl="20" v-if="taskTab == 'third'">
                        <el-row style="padding: 9px 0; color: #333333">
                            <el-col :span="6">
                                <span v-if="item.orderCode != undefined"><u style="color: #00f; cursor: pointer" @click="goViewUpper(item.orderCode,item.boxCode)">{{ item.orderCode }}</u></span>
                                <span v-else>-</span>
                            </el-col>
                            <el-col :span="4">操作类型</el-col>
                            <el-col :span="4">数量</el-col>
                            <el-col :span="4">箱号</el-col>
                            <el-col :span="6">入库时间</el-col>
                        </el-row>
                        <el-row style="padding: 9px 0; color: #666666">
                            <el-col :span="6">{{ item.fcCode }} - {{item.whCode}}</el-col>
                            <el-col :span="4">
                                <span v-if="item.opperType = '10'">来料上架</span>
                                <span v-else-if="item.opperType = '20'">退料上架</span>
                                <!-- <span v-else-if="item.opperType = '30'">调拨上架</span>
                                <span v-else-if="item.opperType = '40'">杂入上架</span> -->
                                <span v-else-if="item.opperType == undefined">-</span>
                            </el-col>
                            <el-col :span="4">
                                <span v-if="item.matQuan != undefined">{{ item.matQuan }}</span>
                                <span v-else>-</span>
                            </el-col>
                            <el-col :span="4">
                                <span v-if="item.boxBarcode != undefined">{{ item.boxBarcode }}</span>
                                <span v-else>-</span>
                            </el-col>
                            <el-col :span="6">
                                <span v-if="item.matCreateTime != undefined">{{ item.matCreateTime }}</span>
                                <span v-else>-</span>
                            </el-col>
                        </el-row>
                    </el-col>
                    <!-- 待拣配 -->
                    <el-col :lg="20" :xl="20" v-if="taskTab == 'fourth'">
                        <el-row style="padding: 9px 0; color: #333333">
                            <el-col :span="6">
                                <span v-if="item.spCode != undefined"><u style="color: #00f; cursor: pointer" @click="goViewPick(item.spCode,item.operaType)">{{ item.spCode }}</u></span>
                                <span v-else>-</span>
                            </el-col>
                            <el-col :span="6">物料编号</el-col>
                            <el-col :span="6">需求数量</el-col>
                            <el-col :span="6">需求时间</el-col>
                        </el-row>
                        <el-row style="padding: 9px 0; color: #666666">
                            <el-col :span="6">{{ item.fcCode }} - {{ item.whCode }}</el-col>
                            <el-col :span="6">
                                <span v-if="item.matCode != undefined">{{ item.matCode }}</span>
                                <span v-else>-</span>
                            </el-col>
                            <el-col :span="6">
                                <span v-if="item.matQuan != undefined">{{ item.matQuan }}</span>
                                <span v-else>-</span>
                            </el-col>
                            <el-col :span="6">
                                <span v-if="item.requireTime != undefined">{{ item.requireTime }}</span>
                                <span v-else>-</span>
                            </el-col>
                        </el-row>
                    </el-col>
                    <!-- 待配送 -->
                    <el-col :lg="20" :xl="20" v-if="taskTab == 'fifth'">
                        <el-row style="padding: 9px 0; color: #333333">
                            <el-col :span="6">
                                <span v-if="item.operaCode != undefined"><u style="color: #00f; cursor: pointer" @click="goViewMat(item.operaCode)">{{ item.operaCode }}</u></span>
                                <span v-else></span>
                            </el-col>
                            <el-col :span="6">物料编号</el-col>
                            <el-col :span="6">数量</el-col>
                            <el-col :span="6">箱号</el-col>
                        </el-row>
                        <el-row style="padding: 9px 0; color: #666666">
                            <el-col :span="6">{{ item.fcCode }} - {{ item.whCode }}</el-col>
                            <el-col :span="6">
                                <span v-if="item.matCode != undefined">{{ item.matCode }}</span>
                                <span v-else>-</span>
                            </el-col>
                            <el-col :span="6">
                                <span v-if="item.matQuan != undefined">{{ item.matQuan }}</span>
                                <span v-else>-</span>
                            </el-col>
                            <el-col :span="6">
                                <span v-if="item.boxBarcode != undefined">{{ item.boxBarcode }}</span>
                                <span v-else>-</span>
                            </el-col>
                        </el-row>
                    </el-col>
                    <!-- 质量待检 -->
                    <el-col :lg="20" :xl="20" v-if="taskTab == 'sixth'">
                        <el-row style="padding: 9px 0; color: #333333">
                            <el-col :span="6">
                                <span v-if="item.orderCode != undefined"><u style="color: #00f; cursor: pointer" @click="goViewQuality(item.orderCode,item.sqCode,item.boxCode)">{{ item.orderCode }}</u></span>
                                <span v-else></span>
                            </el-col>
                            <el-col :span="5">质检单号</el-col>
                            <el-col :span="4">物料编号</el-col>
                            <el-col :span="4">数量</el-col>
                            <el-col :span="4">箱号</el-col>
                        </el-row>
                        <el-row style="padding: 9px 0; color: #666666">
                            <el-col :span="6">{{ item.fcCode }} - {{ item.whCode }}</el-col>
                            <el-col :span="5">
                                <span v-if="item.sqCode != undefined">{{ item.sqCode }}</span>
                                <span v-else>-</span>
                            </el-col>
                            <el-col :span="4">
                                <span v-if="item.matCode != undefined">{{ item.matCode }}</span>
                                <span v-else>-</span>
                            </el-col>
                            <el-col :span="4">
                                <span v-if="item.matQuan != undefined">{{ item.matQuan }}</span>
                                <span v-else>-</span>
                            </el-col>
                            <el-col :span="4">
                                <span v-if="item.boxCode != undefined">{{ item.boxCode }}</span>
                                <span v-else>-</span>
                            </el-col>
                        </el-row>
                    </el-col>
                    <!-- 生产叫料 -->
                    <el-col :lg="20" :xl="20" v-if="taskTab == 'seventh'">
                        <el-row style="padding: 9px 0; color: #333333">
                            <el-col :span="9">
                                <span v-if="item.pmCode != undefined"><u style="color: #00f; cursor: pointer" @click="goViewProduct(item.pmCode)">{{ item.pmCode }}</u></span>
                                <span v-else></span>
                            </el-col>
                            <el-col :span="6">物料编号</el-col>
                            <el-col :span="9">需求数量</el-col>
                        </el-row>
                        <el-row style="padding: 9px 0; color: #666666">
                            <el-col :span="9">{{ item.fcCode }} - {{ item.whCode }}</el-col>
                            <el-col :span="6">
                                <span v-if="item.matCode != undefined">{{ item.matCode }}</span>
                                <span v-else>-</span>
                            </el-col>
                            <el-col :span="9">
                                <span v-if="item.matRealQuan != undefined">{{ item.matRealQuan }}</span>
                                <span v-else>-</span>
                            </el-col>
                        </el-row>
                    </el-col>
                    <!-- AGV -->
                    <el-col :lg="20" :xl="20" v-if="taskTab == 'eighth'">
                        <el-row style="padding: 9px 0; color: #333333">
                            <el-col :span="6">小车编号：{{ item.robotCode }}</el-col>
                            <!-- <el-col :span="6">任务号：{{ item.taskCode }}</el-col> -->
                            <el-col :span="6">内容：{{ item.warnContent }}</el-col>
                            <el-col :span="6">时间：{{ item.createTime }}</el-col>
                        </el-row>
                    </el-col>
					<!-- 待审批列表 -->
                    <el-col :lg="20" :xl="20" v-if="taskTab == 'ninth'">
                    	<el-row style="padding: 9px 0; color: #333333">
                            <el-col :span="6">
                                <span v-if="item.samCode != undefined"><u style="color: #00f; cursor: pointer" @click="goViewExamine(item.samCode)">{{ item.samCode }}</u></span>
                                <span v-else>-</span>
                            </el-col>
                            <el-col :span="5">物料编号</el-col>
                            <el-col :span="4">需求数量</el-col>
                            <el-col :span="4">申请人员</el-col>
                            <el-col :span="5">申请时间</el-col>
                        </el-row>
                        <el-row style="padding: 9px 0; color: #666666">
                            <el-col :span="6">{{ item.fcCode }} - {{ item.deptName }}</el-col>
                            <el-col :span="5">
                                <span v-if="item.matCode != undefined">{{ item.matCode }}</span>
                                <span v-else>-</span>
                            </el-col>
                            <el-col :span="4">
                                <span v-if="item.matQuan != undefined">{{ item.matQuan }}</span>
                                <span v-else>-</span>
                            </el-col>
                            <el-col :span="4">
                                <span v-if="item.person != undefined">{{ item.person }}</span>
                                <span v-else>-</span>
                            </el-col>
                            <el-col :span="5">
                                <span v-if="item.createTime != undefined">{{ item.createTime }}</span>
                                <span v-else>-</span>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </box>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Home",
        components: {},
        data() {
            return {
                taskTab: "third",
                  taskList: [
                    //   {
                //         code: "库龄预警",
                //         fcCode: "预警简介预警简介预警简介预警简介预警简介预警简介预警简介",
                //         person: "张克明",
                //         createTime: "2021/08/19 15:33:48",
                //     },
                //     {
                //         code: "保质期预警",
                //         fcCode: "预警简介预警简介预警简介预警简介预警简介预警简介预警简介",
                //         person: "张克明",
                //         createTime: "2021/08/19 15:33:48",
                //     },
                //     {
                //         code: "上架任务",
                //         fcCode: "预警简介预警简介预警简介预警简介预警简介预警简介预警简介",
                //         person: "张克明",
                //         createTime: "2021/08/19 15:33:48",
                //     },
                //     {
                //         code: "拣货任务",
                //         fcCode: "预警简介预警简介预警简介预警简介预警简介预警简介预警简介",
                //         person: "张克明",
                //         createTime: "2021/08/19 15:33:48",
                //     },
                //     {
                //         code: "配送任务",
                //         fcCode: "预警简介预警简介预警简介预警简介预警简介预警简介预警简介",
                //         person: "张克明",
                //         createTime: "2021/08/19 15:33:48",
                //     },
                ],
                search: {
                    val1: "",
                },

                taskCount: "",
                sumWeek: "",
                sumDay: "",
                upperCount:"",
                pickCount:"",
                pickPeiCount:"",
                productCount:"",
                qualityCount:"",


                roleCode: localStorage.getItem("roleCode")
            };
        },
        created() {
            this.getHomeCount();
            this.getHome();
            // this.getStockPickPage();
        },

        methods: {

            getHomeData() {
                if (this.taskTab != 'first') {
                    this.taskList = []
                    this.$http
                        .request({
                            url: "/api/home/getHomeData",
                            method: "GET",
                            showLoading: true,
                            params: {
                                person: "",
                                fcCode: localStorage.getItem("fcCode") || "",
                                whCode: "",
                                taskTab: this.taskTab
                            }
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.taskList = resp.data.list
                            }
                        })
                        .catch((error) => {});
                } else {
                    this.taskList = [{
                            code: "库龄预警",
                            fcCode: "预警简介预警简介预警简介预警简介预警简介预警简介预警简介",
                            person: "张克明",
                            createTime: "2021/08/19 15:33:48",
                        },
                        {
                            code: "保质期预警",
                            fcCode: "预警简介预警简介预警简介预警简介预警简介预警简介预警简介",
                            person: "张克明",
                            createTime: "2021/08/19 15:33:48",
                        },
                        {
                            code: "上架任务",
                            fcCode: "预警简介预警简介预警简介预警简介预警简介预警简介预警简介",
                            person: "张克明",
                            createTime: "2021/08/19 15:33:48",
                        },
                        {
                            code: "拣货任务",
                            fcCode: "预警简介预警简介预警简介预警简介预警简介预警简介预警简介",
                            person: "张克明",
                            createTime: "2021/08/19 15:33:48",
                        },
                        {
                            code: "配送任务",
                            fcCode: "预警简介预警简介预警简介预警简介预警简介预警简介预警简介",
                            person: "张克明",
                            createTime: "2021/08/19 15:33:48",
                        },
                    ]
                }
            },
            goViewUpper(code, boxCode) {
                this.$router.push({
                    path: '/PutawayConfirm',
                    query: {
                        orderCode: code,
                        boxCode: boxCode
                    },
                })
            },
            goViewPick(code, type) {
                // if (type != "10") {
                //     this.$router.push({
                //         path: '/PickingConfirmation',
                //         query: {
                //             spCode: code,
                //         },
                //     })
                // } else {
                    this.$router.push({
                        path: '/PickingConfirmationMat',
                        query: {
                            spCode: code,
                        },
                    })
                // }
            },
            goViewMat(code) {
                this.$router.push({
                    path: '/MaterialDistributionNew',
                    query: {
                        pmCode: code,
                    },
                })
            },
            goViewQuality(code, sqCode, boxCode) {
                this.$router.push({
                    path: '/QualityInspectionEntry',
                    query: {
                        orderCode: code,
                        sqCode: sqCode,
                        boxCode: boxCode
                    },
                })
            },
            goViewProduct(pmCode) {
                this.$router.push({
                    path: '/ProductionCall',
                    query: {
                        pmCode: pmCode,
                    },
                })
            },
			goViewExamine(samCode){
                this.$router.push({
                    path: '/getApplyExamine',
                    query: {
                        samCode: samCode,
                    },
                })
			},


            getHome() {
                // if(roleCode == "通道"){
                //     this.taskTab = "seventh"
                // }else if(roleCode == "STA"){
                //     this.taskTab = "sixth"
                // }else if(roleCode == "LEVEL_2"){
                //     this.taskTab = "third"
                // }

                if (this.taskTab == 'fourth') {
                    this.getStockPickPage();
                } else if (this.taskTab == 'third') {
                    //this.getStockUpperList();
                    this.getTableDatakUpper();
                } else if (this.taskTab == 'fifth') {
                    this.getTableData();
                } else if (this.taskTab == 'sixth') {
                    this.getStockQuality();
                } else if (this.taskTab == 'seventh') {
                    this.getStockProduct();
                } else if (this.taskTab == "eighth") {
                    this.getNoticePull();
                } else if (this.taskTab == "ninth") {
                    this.getApprovalPending(); //待审批
                } else {
                    this.taskList = [{
                            code: "库龄预警",
                            fcCode: "预警简介预警简介预警简介预警简介预警简介预警简介预警简介",
                            person: "张克明",
                            createTime: "2021/08/19 15:33:48",
                        },
                        {
                            code: "保质期预警",
                            fcCode: "预警简介预警简介预警简介预警简介预警简介预警简介预警简介",
                            person: "张克明",
                            createTime: "2021/08/19 15:33:48",
                        },
                        {
                            code: "上架任务",
                            fcCode: "预警简介预警简介预警简介预警简介预警简介预警简介预警简介",
                            person: "张克明",
                            createTime: "2021/08/19 15:33:48",
                        },
                        {
                            code: "拣货任务",
                            fcCode: "预警简介预警简介预警简介预警简介预警简介预警简介预警简介",
                            person: "张克明",
                            createTime: "2021/08/19 15:33:48",
                        },
                        {
                            code: "配送任务",
                            fcCode: "预警简介预警简介预警简介预警简介预警简介预警简介预警简介",
                            person: "张克明",
                            createTime: "2021/08/19 15:33:48",
                        },
                    ]
                }

            },
            getNoticePull() {
                this.$http
                    .request({
                        url: "/api/agvWarningInfo/getAgvWarningInfo",
                        method: "GET",
                        showLoading: true,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.taskList = resp.data.list || [];
                        }
                        
                    })
                    .catch((error) => {
                        this.$notify({
                            message: "操作失败",
                            type: "danger",
                        });
                    });
            },
			/**
			 * 待审批列表
			 */
			getApprovalPending(){
				this.$http
					.request({
						url: "/api/auxiMaterial/getExamineAuxi",
						method: "GET",
						params: {
							person: localStorage.getItem("empNumber") || "",
						},
					})
					.then((resp) => {
						if (resp.status == 100) {
							this.taskList = resp.data.list || [];
						}
					})
					.catch((error) => {
						this.$message({
							message: "操作失败",
							type: "warning",
						});
					});
			},
            /**
             * 查询拣货单记录
             */
            getStockPickPage() {
                this.taskList = []
                this.$http
                    .request({
                        url: "/api/order/getStockPickPage",
                        method: "GET",
                        params: {
                            // person: this.mainSearch.person || null,
                            // whCode: localStorage.getItem("whCode") || "",
                            fcCode: localStorage.getItem("fcCode") || "",
                            spStatus: "CREATE,EXECUTE",
							// operaType: "10,30,60",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.taskList = resp.data.list || [];
                        }
                    });
            },
            /**
             * 上架信息_推荐库位
             */
            getStockUpperList() {
                this.taskList = []
                this.$http
                    .request({
                        url: "/api/order/getStockUpperList",
                        method: "GET",
                        params: {
                            // person: this.createSearch.person || null,
                            // whCode: localStorage.getItem("whCode") || "",
                            fcCode: localStorage.getItem("fcCode") || "",
                            status: "CREATE" || null,
                            wareType: '10'
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.taskList = resp.data.list || [];
                        }
                    });
            },

            /* 获取首页的数据 */
            getTableDatakUpper() {
                this.$http
                    .request({
                        url: "/api/order/getStockList",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            lcType: "FLOOR",
                            pageNum: 1,
                            pageSize: 200,
                            // pageNum: this.mainSearch.pageNum,
                        },
                    })
                    .then((res) => {
                    if (res.status == 100) {
                        this.taskList = res.data.list || [];
                        //this.mainSearch.total = res.data.total;
                    } else {
                        this.$message.error("错误");
                    }
                    })
                    .catch((error) => {
                    this.$message.error("错误");
                    });
            },
            /**
             * 配送
             */
            getTableData() {
                this.taskList = []
                this.$http
                    .request({
                        url: "/api/stockPickDetail/getStockPickDetailData",
                        method: "GET",
                        params: {
                            // whCode: this.mainSearch.whCode || null,
                            fcCode: localStorage.getItem("fcCode") || "",
                            // person: this.mainSearch.person || null,
                            distrType: "10,20",
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.taskList = res.data.list;
                        }
                    });
            },
            /**
             * 质检
             */
            getStockQuality() {
                this.taskList = []
                this.$http
                    .request({
                        url: "/api/order/getStockQuality",
                        method: "GET",
                        params: {
                            // whCode: this.quaSearch.whCode,
                            fcCode: localStorage.getItem("fcCode") || "",
                            result: "WAIT,PICK",
                            pageNum: 1,
                            pageSize: 99999,
                            // person: this.quaSearch.person || null,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.taskList = res.data.list;
                        }
                    });
            },
            /**
             * 生产叫料
             */
            getStockProduct() {
                this.taskList = []
                this.$http
                    .request({
                        url: "/api/stockProduceMat/getStockProductList",
                        method: "GET",
                        params: {
                            // person: localStorage.getItem("user") || "",
                            fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
														whCode: localStorage.getItem("whCode") || "", //通道编号
                            status: "PICK,PICKING,PICKCOMPLETE",
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.taskList = res.data.list;
                        }
                    });
            },

            /**
             * 待办
             */
            getHomeCount() {
                this.$http
                    .request({
                        url: "/api/home/getHomeCount",
                        method: "GET",
                        params: {
                            person: localStorage.getItem("user"),
                            whCode: localStorage.getItem("whCode") || "",
                            fcCode: localStorage.getItem("fcCode") || "",
                            roleCode: this.roleCode
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.taskCount = resp.data.list[0].taskCount
                            this.sumWeek = resp.data.list[0].sumWeek
                            this.sumDay = resp.data.list[0].sumDay
                            this.upperCount = resp.data.list[0].upperCount
                            this.pickCount = resp.data.list[0].pickCount
                            this.pickPeiCount = resp.data.list[0].pickPeiCount
                            this.productCount = resp.data.list[0].productCount
                            this.qualityCount = resp.data.list[0].qualityCount
                        }
                    });
            },


        }
    };
</script>
<style lang="scss">
    .title {
        font-size: 32px;
        font-weight: bold;
        text-align: left;
        margin: 1vh 0;
    }

    @mixin img-div {
        border-radius: 24px;
        width: 69px;
        height: 69px;
    }

    .img-div1 {
        @include img-div();
        background-image: linear-gradient(0deg, #fcbe2e 0%, #ffa837 100%);
        box-shadow: 0px 3px 17px 0px rgba(251, 156, 47, 0.45);
    }

    .img-div2 {
        @include img-div();
        background-image: linear-gradient(0deg, #658eff 0%, #2462dc 100%);
        box-shadow: 0px 3px 17px 0px rgba(47, 108, 251, 0.45);
    }

    .img-div3 {
        @include img-div();
        background-image: linear-gradient(0deg, #37dcd1 0%, #19cf86 100%);
        box-shadow: 0px 3px 17px 0px rgba(47, 251, 181, 0.45);
    }

    @mixin num-color {
        font-size: 36px;
        padding: 0 16px;
    }

    .num-color1 {
        @include num-color();
        color: #feae34;
    }

    .num-color2 {
        @include num-color();
        color: #306ae2;
    }

    .num-color3 {
        @include num-color();
        color: #1ed193;
    }

    @mixin lamp-div {
        width: 75px;
        height: 75px;
        border-radius: 10px;
    }

    .lamp-div1 {
        @include lamp-div();
        background-color: #f9856d;
    }

    .lamp-div2 {
        @include lamp-div();
        background-color: #8d2cfc;
    }

    .lamp-div3 {
        @include lamp-div();
        background-color: #1f6cec;
    }

    .whiteSpace {
        text-align: center;

        span {
            display: block;
        }
    }

    .task-tab {
        overflow: hidden;
    }
</style>